export default function BenefitsSection() {
  const benefits = [
    { icon: "ri-check-double-line", title: "Produtos Selecionados", desc: "Curadoria manual dos melhores produtos disponíveis no Hoobuy." },
    { icon: "ri-link-m", title: "Links Verificados", desc: "Todos os links passam por revisão antes de serem adicionados à planilha." },
    { icon: "ri-refresh-line", title: "Atualizações Frequentes", desc: "A spreadsheet é atualizada semanalmente com novos produtos e preços." },
    { icon: "ri-translate-2", title: "Guias em Português", desc: "Conteúdo completo em português para facilitar as suas compras." },
    { icon: "ri-scales-3-line", title: "Comparações de Preços", desc: "Tabelas comparativas para ajudar a encontrar o melhor custo-benefício." },
    { icon: "ri-shield-check-line", title: "Dicas de Segurança", desc: "Orientações para comprar com segurança e evitar fraudes." },
  ];

  return (
    <section className="relative bg-background-50 py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4">
            Porquê Nós
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium mb-4">
            Por que usar a nossa Hoobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            A planilha mais completa e atualizada para compradores portugueses
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100/70 rounded-2xl p-6 md:p-8 hover:bg-background-100 transition-colors cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 font-medium mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}